var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{attrs:{"color":_setup.items[_setup.index].color,"size":_vm.size}},[_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_setup.items[_setup.index]?.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }